
import React, { useState } from 'react';
import UI from "components/UI";
import { Link , useLocation, useHistory } from 'react-router-dom';
import PageContainer from 'publish/layout/PageContainer';
import LayoutAside from "../../../layout/LayoutAside";
import Button from 'components/buttons/';
import UIInput from 'components/input/input';
import CommonUtil from 'utils/CommonUtil';
import StringUtil from 'utils/StringUtil';

import UIUtils from "utils/UIUtils";
import UITextArea from "components/atoms/textarea/UITextArea";
function ContentsContainer() {

	const location = useLocation();
	const receivedData = (location.state as any)?.data;
	const history = useHistory();

	const [totalRowCnt,setTotalRowCnt] = useState(0);
	const [showRowCnt,setShowRowCnt] = useState(20); //기본 row count
	

	// @ts-ignore
	let destInfoItems: {PHONE_NUMBER:string;DEST_NAME:string;}[] = [];		
	// @ts-ignore
	let destInfoItem: {PHONE_NUMBER:string; DEST_NAME:string;} = {};


	//초기 데이터 설정
	let totalCnt:number = 0;
	let SheetData = {};
	const [destInfo, setDestInfo] = useState({});  //수신자 정보 이름과 번호 저장

	const [msgId, setMsgId] = useState('');
	const [scheduleType, setScheduleType] = useState('');   //발송시점 구분 (즉시전송:0,  예약전송:1)
	const [nowDate, setNowDate] = useState('');  //DB 입력 시간: YYYYMMDDHHMMSS
	const [sendDate, setSendDate] = useState('');  //발송 희망 시간: YYYYMMDDHHMMSS
	const [destType, setDestType] = useState(0);  //수신자 정보 저장 타입 (0:TEXT  고정)
	const [destCount, setDestCount] = useState(0);  //수신자 목록 개수 (Max : 100)
	const [destInfoList, setDestInfoList] = React.useState<any[]>([]);  //수신자 정보 이름과 번호 저장
	const [callback, setCallback] = useState('');  //콜백번호(회신번호) - 발송자 SMS 번호
	const [subject, setSubject] = useState('');  //제목
	const [smsMsg, setSmsMsg] = useState('');  //발송 SMS 메시지 (80 byte)
	const [reserved1Nm, setReserved1Nm] = useState('');  //발송자 이름
	
	var ib = ib||{};
	ib = {
	//시트 초기화 구문
	'init':{
		"Cfg": {
			"SearchMode": 1,
			//"PageLength": 20,
			"AutoRowHeight": 1,
			"InfoRowConfig": "0",
			"Alternate":"0"
			
		},
		//틀고정 좌측 컬럼 설정
		"LeftCols": [
			{"Header": "No","Name": "SEQ","Width": "90"}
			],
		"Cols": [
			{"Header": "No","Type": "Int", "Name": "","Align": "Center","RelWidth": 1},
			{"Header": "수신유형","Type": "Text", "Name": "CALLBACK_TYPE","MinWidth": 50,"Align": "Center","CanEdit": 0,"RelWidth": 1},
			{"Header": "수신자 SMS번호","Type": "Text","Name": "PHONE_NUMBER","MinWidth": 60,"Align": "Center","CanEdit": 0,"RelWidth": 3},
			{"Header": "수신자 이름","Type": "Text","Name": "DEST_NAME","MinWidth": 40,"Align": "Center","CanEdit": 0,"RelWidth": 1}
		]
	
	},
	//시트 이벤트
	'event':{
	
		onRenderFirstFinish:function (evtParam) {
			//@ts-ignore	
			sheet.InfoRow.Visible = 0; // 페이지네비게이션 표시 안함
		}
		
	},
	//시트객체 생성
	'create':function () {
		let options = this.init;
	
		//@ts-ignore
		options.Events = this.event;
		//@ts-ignore
		IBSheet.create({
			id: 'sheet', // 생성할 시트의 id
			el: 'sheetDiv', // 시트를 생성할 Dom 객체 및 id
			options: options, // 생성될 시트의 속성
			data: this.data // 생성될 시트의 정적데이터
		});
		// global 변수 선언
		//@ts-ignore
		window.currentPage = -1;
	},
	//조회 데이터
	'data':[]
	}
	

	// 상세 데이터 가져오기
	async function initCall(paramMsgId){
		let param = {
			"MSG_ID": paramMsgId
		};

		const response:any = await CommonUtil.execute({
			url:'adm_6210_detail',
			data: param,
			progressBar:true
		}).then()

		const result = response.LIST;
        if(response !=null){
			//데이터 바인딩
			setDestInfo(result);
			setSubject(result[0].SUBJECT); //SMS제목 
			setCallback(result[0].CALLBACK); //발송자SMS번호
			setReserved1Nm(result[0].RESERVED1_NM); //발송자이름
			setSmsMsg(result[0].SMS_MSG);  //메세지 내용 
			
		
			//전체ROW개수 
			totalCnt = Object.keys(result).length;
			setTotalRowCnt(Object.keys(result).length);
		        
			//데이터 처리
			ib.data = result;
			// @ts-ignore	
			sheet.loadSearchData(result);  //data 로딩 처리 
			// @ts-ignore	
			sheet.InfoRow.Visible = 0; // 페이지네비게이션 표시 안함
			
		}

	};

	//상세정보 값 가지고 오기
	function getInfo(name){
		if(Object.keys(destInfo).length != 0){
			return destInfo[name];
		}else{
			return '';
		}
	};


	//목록으로
	const goList = () => {
        history.push({
            pathname: './adm6200',
            state: {data: receivedData}
        });
    }

	// init 
	React.useEffect(() => {
		
		//ib시트 생성
		ib.create();

		if(receivedData != undefined){
			let vMsgId = StringUtil.defaultString(receivedData.vMSG_ID);
			setMsgId(vMsgId)
			//상세데이터 가지고 오기
			initCall(vMsgId);
		}
	
        return () => {
          // @ts-ignore
          IBSheet.disposeAll(true);		  
		 
        }
    },[])


	return (
		<PageContainer>
			<LayoutAside />
				<div className="fww-con">

					<ul className="fww-brd">
						<li className=""><a href="">홈</a></li>
						<li className=""><a href="">관리자페이지</a></li>
						<li className=""><a href="">시스템관리</a></li>
						<li className=""><a href="">SMS발송 관리</a></li>
					</ul>

					<main className="fww-main">
						<h1 className="tx tx-hd2">SMS 발송내역 상세</h1>
						<form className="fo fo-col2 mb30" name="" action="" method="">
							<div className="inner">
								<div className="fo-item fo-m-1-3">
									<p className="fo-key">SMS 제목</p>
									<div className="fo-value">
										<UIInput className={'tf tf-md w100p'} value={subject} valueChanged={(value) => setSubject(value)} placeholder="" readOnly={true}/>
									</div>
								</div>
								<div className="fo-item fo-m-1-3">
									<p className="fo-key">발송자 SMS 번호</p>
									<div className="fo-value">
										<UIInput className={'tf tf-md w100p'} value={callback} valueChanged={(value) => setCallback(value)} placeholder="" readOnly={true}/>
									</div>						
								</div>
								<div className="fo-item fo-m-1-3">
									<p className="fo-key">발송자 이름</p>
									<div className="fo-value">
										<UIInput className={'tf tf-md w100p'} value={reserved1Nm} valueChanged={(value) => setReserved1Nm(value)} placeholder="" readOnly={true}/>
									</div>						
								</div>		
							</div> 
						</form>					
						<div className="tb-top">
							<div>
								<p className="tx fc-black"></p>총 <em className="fw500">{totalRowCnt}</em>건
							</div>
						</div>
						<div id='sheetDiv' className='h100p'>[D] IBSHEET 영역</div>
						
						<div className="fo-item fo-m-1-3">
							{/* <div className="fo-key">SMS 내용</div> */}
							<br/>
							<div className="fo-value">
								<div className="ta-group w100p">
									<UITextArea className={'ta-ip'}  value={smsMsg} valueChanged={(value) => {setSmsMsg(value)}}  attrs={{ rows: 5 }}/>
								</div>
							</div>
						</div>
						
						<div className="hz-root hz-right mt10">
							<Button color="gray-o" size="sm" onClick={goList}>목록</Button>
						</div>							
					</main>

				</div>
		</PageContainer>
	);
}
export default ContentsContainer;

